import { useState } from "react";

import AddPaymentMethodModal from "Payments/ManagePaymentMethods/AddPaymentMethodModal";
import { useManagePaymentMethods } from "Payments/ManagePaymentMethods/ManagePaymentMethodsContext";

import { usePaymentMethod } from "../PaymentMethodContext";

import { QuickControlButton } from "./";

export default function EditButton({
  disabled,
  updateExternalPaymentMethods,
  networkName,
}) {
  const { state: mpmState, dispatch: mpmDispatch } = useManagePaymentMethods();
  const { userID, hasMobilePhone, otherHoHNames } = mpmState?.user;
  const { state } = usePaymentMethod();
  const [showEditPanel, setShowEditPanel] = useState(false);

  const openEditPanel = () => setShowEditPanel(true);

  const closeEditPanel = () => setShowEditPanel(false);

  const setPaymentMethods = (paymentMethods = []) => {
    mpmDispatch({
      type: "Set Payment Methods",
      payload: paymentMethods.sort((PM) =>
        PM.isDefaultPaymentMethod ? -1 : 0
      ),
    });
    if (updateExternalPaymentMethods)
      updateExternalPaymentMethods(paymentMethods);
  };

  return (
    <>
      <QuickControlButton
        icon="fas fa-pencil"
        text="Edit"
        onButtonClick={openEditPanel}
        disabled={disabled}
      />
      <AddPaymentMethodModal
        show={showEditPanel}
        setShow={setShowEditPanel}
        setPaymentMethods={setPaymentMethods}
        userID={userID}
        existingPaymentMethod={{ ...state }}
        sharableWith={otherHoHNames}
        isAlreadyExisting={true}
        hasOtherPaymentMethods={true}
        hasMobilePhone={hasMobilePhone}
        networkName={networkName}
        initialShouldRetokenize={state?.needsUpdate}
      />
    </>
  );
}

//NOTE: SHARABLE WITH NEEDS TO COME FROM PROFILE
